import * as React from 'react'

const Question = ({ children }: { children: string }) => (
  <p className="sp-font-bold sp-break-words">{children}</p>
)

export default Question
